import colors from '@/utils/colors';
const { computerColor, mobileColor, notClassifiedColor } = colors;

export default {
  data() {
    return {
      computerColor,
      mobileColor,
      notClassifiedColor,
    };
  },
  methods: {
    getDeviceColor(title) {
      switch (title) {
      case 'Computador':
        return this.computerColor;

      case 'Celular/Tablet':
        return this.mobileColor;

      case 'Não Classificados':
      default:
        return this.notClassifiedColor;
      }
    },
  },
};
